const INITIAL_STATE = {
	opened: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
	default:
	  return state;
  }
};